import { render, staticRenderFns } from "./Upload.vue?vue&type=template&id=67bb8cdd"
import script from "./Upload.vue?vue&type=script&lang=js"
export * from "./Upload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../szc.cycz.cc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/szc.cycz.cc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67bb8cdd')) {
      api.createRecord('67bb8cdd', component.options)
    } else {
      api.reload('67bb8cdd', component.options)
    }
    module.hot.accept("./Upload.vue?vue&type=template&id=67bb8cdd", function () {
      api.rerender('67bb8cdd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/basicSettings/companyInfo/Upload.vue"
export default component.exports